// FA Solid
import { library } from '@fortawesome/fontawesome-svg-core'

import point from './icons/point'
import grab from './icons/grab'
import chevronRight from './icons/chevron-right'
import user from './icons/user'

const icons = {
	point,
	grab,
	chevronRight,
	user,
}

library.add(icons)

export default icons;